import { render, staticRenderFns } from "./FancyHeader.vue?vue&type=template&id=0fbeea00&lang=pug&"
import script from "./FancyHeader.vue?vue&type=script&lang=js&"
export * from "./FancyHeader.vue?vue&type=script&lang=js&"
import style0 from "./FancyHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports